<template>
  <v-row justify="center" v-show="GameFinishDialog" class="dialog-container">
    <v-dialog v-model="GameFinishDialog" persistent max-width="300">
      <v-card tile flat>
        <v-card-title class="headline">Beküldés</v-card-title>
        <v-card-text>
          <p v-show="draftCount" type="warning">
            A jegyzőkönyvben <strong>{{ draftCount }}</strong> vázlat esemény van, ezeket vagy törölje, vagy
            véglegesítse!
          </p>
          <p v-show="rejectedCount" type="warning">
            A jegyzőkönyvben <strong>{{ rejectedCount }}</strong> nem elfogadott esemény van, ezeket törölje vagy
            módosítsa a versenybíró indoklása szerint!
          </p>
          <p v-show="!draftCount && !rejectedCount">Biztosan kívánja beküldeni az állapotot? Ez a művelet nem
            visszavonható!</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed tile v-show="!draftCount && !rejectedCount" @click="bekuldes">Beküldés</v-btn>
          <v-btn depressed tile @click="GameFinishDialogClose">Mégsem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import Bugsnag from "@bugsnag/js";
import {downloadMatchExport} from "@/utils/matchExport";

export default {
  computed:{
    ...mapState('ui', ['GameFinishDialog']),
    ...mapState('game', ['draftCount', 'rejectedCount'])
  },
  methods:{
    // JAVÍTÁS: Itt hozzáadtam a SET_GAMESYNCDIALOG-ot is, mert ezt is hívja a bekuldes()
    ...mapMutations('ui', ['SET_SHOW_MENU', 'SET_GAMEFINISHDIALOG', 'SET_GAMESYNCDIALOG']),

    // JAVÍTÁS: Bekötöttem a game modult a SET_GAME_FINISHED miatt
    ...mapMutations('game', ['SET_GAME_FINISHED']),

    bekuldes() {
      // Most már elérhetőek ezek a függvények:
      this.SET_GAME_FINISHED(true);
      this.SET_GAMESYNCDIALOG(true);

      this.exportMatchData();
      this.waitForSyncAndFinish();

      this.GameFinishDialogClose();
    },
    // JAVÍTÁS: korábban ha a Beküldés pillanatában MÉG VOLT szinkronizálatlan
    // esemény, a `window.vueio.emit("gamefinished")` SOHA nem futott le (l.
    // isSynced() azonos javítása a db.worker.js-ben) - a szerver ezért sosem
    // küldte vissza a "logout" választ, ami a GameSyncDialog-ot (a
    // "szinkronizálás folyamatban" képernyőt) zárja be - a felhasználó tehát
    // ezen a képernyőn ragadhatott a beküldés után. Mostantól a rendszer
    // türelmesen (1 másodpercenként, max 10 alkalommal) újra megnézi, hogy
    // szinkronban van-e minden, DE - hogy a felhasználó SOSE ragadjon be
    // véglegesen - 10 másodperc után MINDENKÉPP elküldi a "gamefinished"
    // jelzést, akkor is, ha közben nem sikerült minden eseményt felszinkronizálni
    // (ez a tényleges meccs-adatokat nem érinti, azok a normál szinkron
    // mechanizmuson továbbra is eljutnak a szerverre - ez csak a végső
    // jelzést és a felhasználó kiléptetését garantálja).
    waitForSyncAndFinish(attemptsLeft = 10) {
      const self = this;
      window.dbmanager.isSynced().then((synced) => {
        if (synced) {
          window.vueio.emit("gamefinished");
          return;
        }
        if (attemptsLeft > 0) {
          setTimeout(() => self.waitForSyncAndFinish(attemptsLeft - 1), 1000);
        } else {
          console.warn("Beküldés: nem sikerült megvárni a teljes szinkronizálást, a jelzés mindenképp elküldve.");
          Bugsnag.notify("gamefinished sent without full sync confirmation", function (event) {
            event.severity = 'warning';
            event.context = 'GameFinishDialog - sync timeout';
          });
          window.vueio.emit("gamefinished");
        }
      }).catch((err) => {
        console.error("isSynced ellenőrzés sikertelen a beküldésnél:", err);
        Bugsnag.notify(err, function (event) {
          event.severity = 'warning';
          event.context = 'GameFinishDialog - isSynced check failed';
        });
        // JAVÍTÁS: a korábbi kódban egy hiba itt (pl. "No DB") a `gamefinished`
        // teljes, csendes elmaradását okozta volna - a felhasználó nem
        // ragadhat be emiatt, ezért itt is elküldjük a jelzést.
        window.vueio.emit("gamefinished");
      });
    },
    exportMatchData() {
      // A tényleges munka a közös `src/utils/matchExport.js`-ben van. Csendes
      // módban fut: a beküldés folyamatát egy sikertelen mentés sem akaszthatja
      // meg, és felugró ablakkal sem zavarjuk a felhasználót.
      downloadMatchExport({notify: false});
    },
    GameFinishDialogClose() {
      this.SET_GAMEFINISHDIALOG(false);
      this.SET_SHOW_MENU(false);
    },
  }
}
</script>

<style scoped>

</style>
